
export const FILTER_GLOW_BEIGE_ID = 'filter--glow-beige';

export const FilterGlowBeige = () => (
  <filter id={FILTER_GLOW_BEIGE_ID} y="-40%" height="180%" x="-40%" width="180%">
    <feMorphology operator="dilate" radius="1" in="SourceAlpha" result="thicken" />
    <feGaussianBlur in="thicken" stdDeviation="8" result="blurred" />
    <feFlood floodColor="#FFF9DE" result="glowColor" floodOpacity={0.75} />
    <feComposite in="glowColor" in2="blurred" operator="in" result="softGlow_colored" />

    <feMerge>
      <feMergeNode in="softGlow_colored" />
      <feMergeNode in="SourceGraphic" />
    </feMerge>
  </filter>
);
